import { TOKEN_SCOPES } from '@/router'
export const isFullAccessLogin = (state) => state.userTokenScope.includes(TOKEN_SCOPES.FULL_ACCESS)
